import { InputValidationRuleType } from 'src/constants';
import {
    AT_MOST_N_CHAR,
    IS_REQUIRED,
    MAXIMUM_ONE_DECIMAL,
    MUST_BE_VALID_FRACTION_GREATER_0_LESS_EQUAL_1,
    MUST_GREATER_0_LESS_EQUAL_1,
    MUST_GREATER_EQUAL_0_LESS_EQUAL_1,
    MUST_GREATER_EQUAL_1,
    MUST_GREATER_EQUAL_1_LESS_EQUAL_99,
    MUST_GREATER_EQUAL_NEGATIVE_1_LESS_EQUAL_1
} from 'src/constants/errorMessages';
import {
    validateIsFraction,
    validateMaxLength,
    validateNumberDecimalPosition,
    validateNumberRange,
    validateRequired
} from 'src/util/validationsUtil';

interface InputRuleObj {
    method: (value: string) => boolean;
    errorMessage: string;
}

export const inputValidationRuleMap: Map<InputValidationRuleType, InputRuleObj> = new Map([
    [
        InputValidationRuleType.Required,
        {
            method: (value: string) => validateRequired(value),
            errorMessage: IS_REQUIRED
        }
    ],
    [
        InputValidationRuleType.Max8Char,
        {
            method: (value: string) => validateMaxLength(value, 8),
            errorMessage: AT_MOST_N_CHAR(8)
        }
    ],
    [
        InputValidationRuleType.Greater0LessEqual1,
        {
            method: (value: string) => validateNumberRange(value, 0, false, 1, true),
            errorMessage: MUST_GREATER_0_LESS_EQUAL_1
        }
    ],
    [
        InputValidationRuleType.GreaterEqual0LessEqual1,
        {
            method: (value: string | number) => validateNumberRange(value, 0, true, 1, true),
            errorMessage: MUST_GREATER_EQUAL_0_LESS_EQUAL_1
        }
    ],
    [
        InputValidationRuleType.OneDecimal,
        {
            method: (value: string | number) => validateNumberDecimalPosition(value, 1),
            errorMessage: MAXIMUM_ONE_DECIMAL
        }
    ],
    [
        InputValidationRuleType.GreaterEqual1,
        {
            method: (value: string) => validateNumberRange(value, 1, true, Number.MAX_SAFE_INTEGER, true),
            errorMessage: MUST_GREATER_EQUAL_1
        }
    ],
    [
        InputValidationRuleType.GreaterEqual1LessEqual99,
        {
            method: (value: string | number) => validateNumberRange(value, 1, true, 99, true),
            errorMessage: MUST_GREATER_EQUAL_1_LESS_EQUAL_99
        }
    ],
    [
        InputValidationRuleType.GreaterEqualNegative1LessEqual1,
        {
            method: (value: string | number) => validateNumberRange(value, -1, true, 1, true),
            errorMessage: MUST_GREATER_EQUAL_NEGATIVE_1_LESS_EQUAL_1
        }
    ],
    [
        InputValidationRuleType.FractionGreater0LessEqual1,
        {
            method: (value: string) => validateIsFraction(value),
            errorMessage: MUST_BE_VALID_FRACTION_GREATER_0_LESS_EQUAL_1
        }
    ]
]);
